import * as React from 'react';

import {
  Chevron,
  ImagePlaceholder,
  PopupBoxWrapper,
  StyledCdnImage,
  StyledImage,
} from './styled';

interface PopupBoxProps {
  onClick?: () => void;
  dataTestId?: string;
  cdnImageUrl?: string;
  publicImageUrl?: string;
  imageAlt?: string;
  children?: React.ReactNode;
}

export const PopupBox = React.forwardRef<HTMLDivElement, PopupBoxProps>(
  (
    {
      children,
      dataTestId,
      onClick,
      cdnImageUrl,
      imageAlt = '',
      publicImageUrl,
    },
    ref
  ) => {
    const publicImage = <StyledImage src={publicImageUrl} alt={imageAlt} />;

    const cdnImage = cdnImageUrl ? (
      <StyledCdnImage src={cdnImageUrl} alt={imageAlt} sourceKey="order" />
    ) : (
      <ImagePlaceholder />
    );

    const image = publicImageUrl ? publicImage : cdnImage;

    return (
      <PopupBoxWrapper data-testid={dataTestId} onClick={onClick} ref={ref}>
        <>
          {image}

          {children}
        </>

        <Chevron />
      </PopupBoxWrapper>
    );
  }
);
